// @flow weak

import {GET} from '../helpers/request';
import type {Dispatch} from 'redux';
import type {Exact} from '../reducers/configTemplateView';
import type {OptionalNavigationAction} from './notification';
import type {
  RoomTemplateDto,
  ErrorDto,
} from '../dtos';

export const REQUEST = '@roomTemplateList/REQUEST';
export const SUCCESS = '@roomTemplateList/SUCCESS';
export const FAILURE = '@roomTemplateList/FAILURE';

export const FILTER = '@roomTemplateList/FILTER';
export const SORT = '@roomTemplateList/SORT';

export type RoomTemplateListRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateList/REQUEST',
};
export type RoomTemplateListSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateList/SUCCESS',
  roomTemplates: RoomTemplateDto[],
};
export type RoomTemplateListFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateList/FAILURE',
  error: ErrorDto,
};

export type RoomTemplateListFilterAction = OptionalNavigationAction & {
  type: '@roomTemplateList/FILTER',
  archived: boolean,
  query: ?string
};
export type RoomTemplateListSortAction = OptionalNavigationAction & {
  type: '@roomTemplateList/SORT',
  sorter: Function,
};

export type RoomTemplateListAction
  = RoomTemplateListRequestAction
  | RoomTemplateListSuccessAction
  | RoomTemplateListFailureAction
  | RoomTemplateListFilterAction
  | RoomTemplateListSortAction

const roomTemplatesRequest = (): Exact<RoomTemplateListRequestAction> => ({
  type: REQUEST,
});

const roomTemplatesSuccess = (roomTemplates: RoomTemplateDto[]): Exact<RoomTemplateListSuccessAction> => ({
  type: SUCCESS,
  roomTemplates,
});

const roomTemplatesFailure = (error: ErrorDto): Exact<RoomTemplateListFailureAction> => ({
  type: FAILURE,
  error,
});

export const filterRoomTemplates = (query: ?string, archived: boolean): Exact<RoomTemplateListFilterAction> => ({
  type: FILTER,
  archived,
  query,
});

export const fetchRoomTemplates = () => async (dispatch: Dispatch<RoomTemplateListAction>) => {
  dispatch(roomTemplatesRequest());
  try {
    const roomTemplates = await GET({endpoint: '/roomtemplates'}, dispatch);
    dispatch(roomTemplatesSuccess(roomTemplates));
  } catch (err) {
    dispatch(roomTemplatesFailure(err));
  }
};

export const sortItems = (sorter: Function): Exact<RoomTemplateListSortAction> => ({
  type: SORT,
  sorter,
});



// WEBPACK FOOTER //
// ./src/actions/roomTemplateList.js